import { LoadingIcon } from "melco-ui";
// import { useTranslation } from "react-i18next";
import { useAddSupplier } from "../../hooks/suppliers/useAddSupplier";
import { MACHINES } from "../../helper/suppliers";



type AddMachinesSupplierProps = {

  setIsAddMachinesSupplierDrawerOpenAction: (v: boolean, id: string) => void
};

export const AddMachinesSupplier: React.FC<
  AddMachinesSupplierProps
> = ({ setIsAddMachinesSupplierDrawerOpenAction }) => {
  const [addSupplier, isLoading] = useAddSupplier(MACHINES);

  // const { t } = useTranslation();
  return (
    <>
      {
        <div
          key="add-machines-suppliers"

          onClick={async () => {
            const supplier = await addSupplier();
            if (supplier) {
              console.log(supplier)
              setIsAddMachinesSupplierDrawerOpenAction(true, supplier.id);
            }
          }}

        >
          {/* {t("managesuppliers.actions.add..machine")} */}
          {isLoading && <LoadingIcon />} Machine
        </div>
      }
    </>


  );
};
